import { render, staticRenderFns } from "./_base-nav.vue?vue&type=template&id=01719b13&scoped=true&"
import script from "./_base-nav.vue?vue&type=script&lang=js&"
export * from "./_base-nav.vue?vue&type=script&lang=js&"
import style0 from "./_base-nav.vue?vue&type=style&index=0&id=01719b13&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01719b13",
  null
  
)

export default component.exports